import { getLocale } from "../runtime";

const sv_minreading = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `min läsning`
};

const minreading = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_minreading(inputs)
	return "minReading";
};

export { minreading as "minReading" };